class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.cartForm = this.closest('cart-form');
  }

  connectedCallback() {
    if (this.cartForm) {
      this.observeCartFormChanges();
    }
    this.initOptions();
    const firstOption = this.querySelector('.subs-button');
    console.log(firstOption)
    if (firstOption) {
      this.selectOption(firstOption);
    }
  }

  initOptions() {
    const options = this.querySelectorAll('.subs-button');
    options.forEach(option => {
      option.addEventListener('click', () => this.selectOption(option));
    });
  }

  selectOption(option) {
    const options = this.querySelectorAll('.subs-button');
    options.forEach(opt => opt.classList.remove('selected-plan'));
    option.classList.add('selected-plan');
    this.updateFormData(option);
    this.updateDisplayPrice(option);

  }

  updateDisplayPrice(option) {
    // Find the price element inside the selected option
    const priceElement = option.querySelector('.subscription-price');
    if (priceElement) {
      // Find the price value
      const priceText = priceElement.innerText.trim();

      
      // Extract the numeric value from the price text
      const priceValue = this.extractPriceValue(priceText);
      
      if (priceValue) {
        // Find the product card price in the main add-to-cart section, not all price-quotes
        const addToCartButton = this.cartForm?.querySelector('.AddToCart');
        const stickyATC = this.cartForm?.querySelector('#sticky-product-bar')

        if (addToCartButton) {
          // Find the price-quote within this specific add-to-cart button
          const priceQuote = addToCartButton.querySelector('product-card-price price-quote[data-original-price]');
          const stickyATCpriceQuote = stickyATC?.querySelector('product-card-price price-quote[data-original-price]');
          if (priceQuote) {

            
            // Update the price attribute
            priceQuote.setAttribute('data-price', priceValue);
            stickyATCpriceQuote.setAttribute('data-price', priceValue);
            
            // Trigger the attribute changed callback or re-render
            if (typeof priceQuote.attributeChangedCallback === 'function') {
              priceQuote.attributeChangedCallback('data-price', priceQuote.getAttribute('data-price'), priceValue);
              stickyATC.attributeChangedCallback('data-price', priceQuote.getAttribute('data-price'), priceValue);

            } else {
              // Force re-render
              priceQuote.reRender({ name: 'data-price', oldVal: null, newVal: priceValue });
              stickyATC.reRender({ name: 'data-price', oldVal: null, newVal: priceValue });

            }
          }
        }
      }
    }
  }
  extractPriceValue(priceText) {
    // Extract the numeric value from price text, including decimal part
    const regex = /[\$£€]?\s*([0-9,]+(?:\.[0-9]{1,2})?)/;
    const match = priceText.match(regex);
    
    if (match && match[1]) {
      const value = parseFloat(match[1].replace(/,/g, '')) * 100;

      return Math.round(value); 
    }
    return null;
  }

  updateFormData(option) {
    if (this.cartForm) {
      const dataForm = JSON.parse(this.cartForm.getAttribute('data-form'));
      const items = Object.values(dataForm.items);
      const targetItem = items[0];
      if (targetItem) {
        const payload = {
          id: targetItem.id,
          quantity: targetItem.quantity,
          ...(option.getAttribute('data-plan-id') && {
            selling_plan: option.getAttribute('data-plan-id'),
          }),
          properties: {},
        };
        this.cartForm?.formDataAPI?.updateItems(payload);
      }
    }
  }

  observeCartFormChanges() {
    const observer = new MutationObserver(mutationsList => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-product-card-selected_variant_id') {
          this.handleCartFormUpdate();
        }
      }
    });
    observer.observe(this.cartForm.querySelector("#product-card-section"), { attributes: true, attributeFilter: ['data-product-card-selected_variant_id'] });
    window.addEventListener('beforeunload', () => observer.disconnect());
  }

  handleCartFormUpdate() {
    const dataForm = JSON.parse(this.cartForm.getAttribute('data-form'));
    const variantId = Object.values(dataForm.items)?.[0]?.id;
    const productUrl = this.getAttribute('data-product-url') || window.location.pathname;
    if (variantId) {
      this.classList.add("loading-plans");

      fetch(`${productUrl}?variant=${variantId}`)
        .then(response => {
          if (!response.ok) throw new Error('Failed to fetch updated section');
          return response.text();
        })
        .then(html => {
          const parser = new DOMParser();
          const newDocument = parser.parseFromString(html, 'text/html');
          const newContent = newDocument.querySelector('subs-widget');
          if (newContent) {
            this.replaceWith(newContent);
          }
        })
        .catch(error => {
          console.error('Error updating section:', error);
        });
    }
  }
}
customElements.define('subs-widget', SubscriptionWidget);